export default __webpack_public_path__ + "4be1c4e959e6fec0abe101178b0083c6.svg";